<template>
    <easy-data-table 
        class="mt-4 tablePadding"
        :rows-per-page="rowsPerPage" 
        buttons-pagination
        alternating 
        :headers="headers"
        :items="items" 
        multi-sort
        table-class-name="customize-table"
        border-cell
        header-text-direction="center"
        body-text-direction="center"
        >
        <template #item-operations="item">
            <div class="operation-wrapper">
                <button v-if="hasActionBtn"
                    :title="hasToolTip"
                    @click="actionItem(item)" 
                    class="btn btn-dark btn-sm me-2">
                    <i class="bi bi-pencil-square"></i>
                </button>
                <button v-if="hasTablePermission('update')"
                    title="Edit/View"
                    @click="updateItem(item)" 
                    class="btn btn-primary btn-sm me-2">
                    <i class="bi bi-pencil-square"></i>
                </button>
                <button v-if="hasTablePermission('delete')"
                    title="Delete"
                    @click="deleteItem(item)" class="btn btn-danger btn-sm">
                    <i class="bi bi-trash"></i>
                </button>
                <button v-if="hasTablePermission('pay')"
                    title="Pay"
                    @click="payItem(item)" class="btn btn-primary btn-sm">
                    {{paylabel}}
                </button>
                <button v-if="hasTablePermission('copy')"
                    title="Copy"
                    @click="copyItem(item)" class="btn btn-info btn-sm m-1">
                    <i class="bi bi-copy"></i>
                </button>
            </div>
        </template>
        <template v-if="hasChildTable" #expand="item">
            <div style="padding: 15px">
                <table class="table table-striped table-bordered">
                    <thead>
                        <tr>
                            <th v-for="header in childHeaders" :key="header.key" class="table-header wrap-text">
                            {{ header.label }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="result in childTableData(item)" :key="result.id">
                            <td v-for="header in childHeaders" :key="header.key">{{ result[header.key] }}</td>
                        </tr>
                        <tr v-if="isEmpty(item[childTableKey])">
                            <td colspan="7" style="text-align: center;">No Records found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </easy-data-table>
</template>

<script>
export default {
    name: 'DynamicDataTable',
    components: {
        EasyDataTable: window['vue3-easy-data-table']
    },
    props: {
        rowsPerPage: {
            type: Number,
            default: 10
        },
        headers: {
            type: Array,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        permissionsArray: {
            type: Array,
            default: () => []
        }, 
        hasActionBtn: {
            type: Boolean,
            required: false
        },
        hasToolTip: {
            type: String,
            required: false,
            default: 'Permissions'
        },
        hasChildTable: {
            type: Boolean,
            required: false
        },
        childHeaders: {
            type: Array,
            default: () => [],
        },
        childTableKey: {
            type: String,
            default: 'test',
        },
        isWrapText: {
            type: Boolean,
            required: false
        },
        paylabel: {
            type: String,
            default: "pay",
        },
    },
    methods: {
        hasTablePermission(permission) {
            return this.permissionsArray.includes(permission);
        },
        updateItem(item) {
            this.$emit('update', item);
        },
        deleteItem(item) {
            this.$emit('delete', item);
        },
        actionItem(item) {
            this.$emit('hasAction', item);
        },
        copyItem(item) {
            this.$emit('copy', item);
        },
        payItem(item) {
            this.$emit('pay', item);
        },
        childTableData(item) {
            return item[this.childTableKey] || [];
        }
    },
    computed: {
    }
};
</script>
  
<style scoped>
.tablePadding {
    padding: 0px !important;
}
label {
    font-size: 13px;
}
.font-size-17{
    font-size: 17px;
}

.b-table-alignment{
    margin-left:25px;
    width:85%;
}

.table-header {
    background-color: #30404f;
    color: white;
    text-align: center;
}

table tbody td {
    text-align: center;
}
.wrap-text {
    white-space: normal;
    word-wrap: break-word;
}
.customize-table {
    --easy-table-border: 1px solid #e0e0e0;
    --easy-table-row-border: 1px solid #e0e0e0;

    --easy-table-header-font-size: 13px;
    --easy-table-header-height: 50px;
    --easy-table-header-font-color: white;
    --easy-table-header-background-color: #2f3133;

    /* --easy-table-header-item-padding: 10px 15px; */

    --easy-table-body-even-row-font-color: black;
    --easy-table-body-even-row-background-color: #c4c2c2;


    --easy-table-body-row-font-color: black;
    --easy-table-body-row-background-color: white;
    --easy-table-body-row-height: 30px;
    --easy-table-body-row-font-size: 13px;

    --easy-table-body-row-hover-font-color: #2d3a4f;
    --easy-table-body-row-hover-background-color: #eee;

    --easy-table-body-item-padding: 5px 15px;


    --easy-table-footer-font-color: black;
    --easy-table-footer-font-size: 14px;
    --easy-table-footer-padding: 0px 15px;
    --easy-table-footer-height: 50px;

    --easy-table-rows-per-page-selector-width: 70px;
    --easy-table-rows-per-page-selector-option-padding: 10px;
    --easy-table-rows-per-page-selector-z-index: 1;

    --easy-table-loading-mask-background-color: #2d3a4f;
    --da0d4328: none !important;
}
</style>
